export default __webpack_public_path__ + "static/media/Twilio.9b78aa9e.svg";